import styled from '@emotion/styled';
import { borderRadius, spacing } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import { AppLink } from '../../../AppLink/AppLink';

export const Container = styled.div``;

export const LinkItem = styled(AppLink)`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${nafColor.signature.black} !important;
  padding: ${spacing.space4} ${spacing.space8};
  font-size: 1.125rem;
  font-weight: 400;
  line-height: 1.5rem;
  width: fit-content;

  &:hover {
    text-decoration: none;
    background-color: ${nafColor.signature.yellow40};
    border-radius: ${borderRadius.L};
  }
`;
